<template>
  <svg viewBox="0 0 1024 1024" fill="currentColor">
    <path
      d="M874.24 1013.76H143.36a94.72 94.72 0 0 1-94.72-94.72V188.16a94.72 94.72 0 0 1 94.72-94.72h730.88a95.36 95.36 0 0 1 94.72 94.72v730.88a94.72 94.72 0 0 1-94.72 94.72zM143.36 156.8a31.36 31.36 0 0 0-32 31.36v730.88a32 32 0 0 0 32 32h730.88a32 32 0 0 0 31.36-32V188.16a31.36 31.36 0 0 0-31.36-31.36z"
    />
    <path
      d="M926.08 399.36h-832a32 32 0 0 1 0-64h832a32 32 0 1 1 0 64zM339.84 273.28a31.36 31.36 0 0 1-31.36-32V39.04a31.36 31.36 0 0 1 31.36-32 32 32 0 0 1 32 32v202.24a32 32 0 0 1-32 32zM677.12 273.28a31.36 31.36 0 0 1-31.36-32V39.04a31.36 31.36 0 1 1 64 0v202.24a31.36 31.36 0 0 1-32.64 32zM444.16 841.6a33.92 33.92 0 0 1-23.04-9.6l-128-138.24a32 32 0 1 1 46.08-43.52L448 768l280.32-279.68a30.72 30.72 0 0 1 44.8 0 31.36 31.36 0 0 1 0 44.16L466.56 832a32 32 0 0 1-22.4 9.6z"
    />
  </svg>
</template>
